import * as React from 'react'

import { MatchMedia } from '../MatchMedia'
import {
  HorizontalStepperWrapper,
  Step,
  StepLabel,
  StepNumber,
  VerticalStepperWrapper,
} from './Stepper.styles'

interface StepperProps {
  currentStep: number
  steps: { stepNumber: number; labelText: string }[]
  onClick?: (stepNumber: number) => void
}

interface StepProps {
  currentStep: number
  onClick?: (stepNumber: number) => void
  step: { stepNumber: number; labelText: string }
}

const StepItem: React.SFC<StepProps> = ({ onClick, step, currentStep }) => {
  const selected: boolean = step.stepNumber === currentStep
  return (
    <Step
      isSelected={selected}
      onClick={() => {
        if (onClick) onClick(step.stepNumber)
      }}
    >
      <StepNumber isSelected={selected}>{step.stepNumber}</StepNumber>
      <MatchMedia onlyTabletAndDesktop>
        {selected && (
          <StepLabel isSelected={selected}>{step.labelText}</StepLabel>
        )}
      </MatchMedia>

      <MatchMedia desktop>
        <StepLabel isSelected={selected}>{step.labelText}</StepLabel>
      </MatchMedia>
    </Step>
  )
}

const Stepper: React.SFC<StepperProps> = ({ steps, currentStep, onClick }) => {
  return (
    <>
      <MatchMedia onlyTabletAndDesktop>
        <HorizontalStepperWrapper marginBottom="xs">
          {steps.map((step, index) => (
            <StepItem
              step={step}
              currentStep={currentStep}
              key={index}
              onClick={onClick}
            />
          ))}
        </HorizontalStepperWrapper>
      </MatchMedia>
      <MatchMedia desktop>
        <VerticalStepperWrapper>
          {steps.map((step, index) => (
            <StepItem
              step={step}
              currentStep={currentStep}
              key={index}
              onClick={onClick}
            />
          ))}
        </VerticalStepperWrapper>
      </MatchMedia>
    </>
  )
}

export default Stepper
